import { ContentError } from '@ctw/shared/components/errors/content-error';
import {
  DOCUMENT_RENDERER_CONTENT_TEST_ID,
  DOCUMENT_RENDERER_PLAIN_TEXT_TEST_ID,
} from '@ctw/shared/test/ids';
import { tw } from '@ctw/shared/utils/tailwind';
import { faFileLines } from '@fortawesome/pro-regular-svg-icons';
import { memo, type RefObject } from 'react';

export interface PlainTextRendererProps {
  text: string;
  contentRef: RefObject<HTMLDivElement | null>;
}

export const PlainTextRenderer = memo(({ text, contentRef }: PlainTextRendererProps) => {
  if (text.trim() === '') {
    return (
      <ContentError
        icon={faFileLines}
        title="This document is empty"
        message="There's no text to display for this document."
        className={tw`flex h-full max-h-full min-h-full w-full items-center justify-center`}
      />
    );
  }

  return (
    <div ref={contentRef} data-testid={DOCUMENT_RENDERER_CONTENT_TEST_ID}>
      <pre
        data-testid={DOCUMENT_RENDERER_PLAIN_TEXT_TEST_ID}
        className={tw`h-full max-h-full w-full max-w-full overflow-auto whitespace-pre-wrap px-5 py-4`}
      >
        {text}
      </pre>
    </div>
  );
});

PlainTextRenderer.displayName = 'PlainTextRenderer';
